import { Box, Button, Icon, Modal, Typography } from "@mui/material";
import React from "react";
import { COLOR_CONSTANTS } from "../../../helpers/Colors";
import { Clear, Close, Done } from "@mui/icons-material";
import InvoicePreview from "./InvoicePreview";
import StickyActionBar from "../../../components/mobile/StickyActionBar";

const ViewPOModal = ({ open, invoice, onClose, actionHandler, showActions=true, isMobile = false }) => {
  if (!invoice) return null;
  const { _file, fins_status } = invoice;
  if (!_file) return null;
  const actionButtons = (
    <>
      <Button
        style={{
          backgroundColor: COLOR_CONSTANTS["on-surface/secondary"],
        }}
        variant="contained"
        startIcon={<Clear />}
        onClick={() => {
          onClose();
          actionHandler(invoice, "REJECT");
        }}
      >
        Reject
      </Button>
      <Button
        startIcon={<Done />}
        variant="contained"
        onClick={() => {
          onClose();
          actionHandler(invoice, "ACKNOWLEDGE");
        }}
      >
        {fins_status === "revised" ? "Approve" : "Acknowledge"}
      </Button>
    </>
  );
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        height={"100vh"}
        display={"flex"}
        sx={{ backgroundColor: COLOR_CONSTANTS["on-surface/secondary"] }}
        flexDirection={"column"}
      >
        <Box
          sx={{
            height: "56px",
            padding: isMobile ? "8px 12px" : "10px 8px",
            bgcolor: "white",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            borderBottom: "1px solid #ccc",
          }}
        >
          <Icon onClick={onClose} style={{ cursor: "pointer" }}>
            <Close fontSize="24px" />
          </Icon>
          <Box paddingLeft={"12px"}>
            <Typography variant="body1">{invoice?.po_code}</Typography>
            <Typography variant="subtitle1" style={{ color: "black" }}>
              View PO
            </Typography>
          </Box>
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
          <InvoicePreview
            type={_file?.file_name?.split(".").pop()}
            url={_file?.pre_signed_url}
            scale={isMobile ? 1 : 1.5}
          />
        </Box>
        {showActions && isMobile ? (
          <StickyActionBar>{actionButtons}</StickyActionBar>
        ) : null}
        {showActions && !isMobile ? (
          <Box
            boxShadow={"0px 4px 4px 4px rgba(0, 0, 0, 0.25)"}
            display={"flex"}
            justifyContent={"flex-end"}
            alignItems={"center"}
            columnGap={"12px"}
            flexShrink={0}
            sx={{ bgcolor: "white", padding: "20px 24px" }}
            // position={'absolute'}
            // bottom={0}
          >
            {actionButtons}
          </Box>
        ) : null}
      </Box>
    </Modal>
  );
};

export default ViewPOModal;
